export default __webpack_public_path__ + "static/media/delete.6992223f.svg";